var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('invoicedetail-component'),(false)?_c('invoicePreviewComponent',{attrs:{"invoiceStages":_vm.invoiceStages},model:{value:(_vm.invoice),callback:function ($$v) {_vm.invoice=$$v},expression:"invoice"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }